import { dataTypes, dataClass } from '../common/Constants';
import PlaceData from './PlaceData';
import GeoLocation from './GeoLocation';
import Config from '../common/Config';
import MapData from "../common/MapData";
import GeoService from "../common/GeoService";
import VisibilityService from "../common/VisibilityService";

/** Item as returned by the accommodation list endpoint. */
export interface HotelListItem {
    id: number | string;
    uri?: string;
    url?: string;
    /** Legacy shape. @see geo_location_json */
    geo_location?: { lat: string; lon: string };
    geo_location_json?: string;
    /** Siempre presente: fromListItem hace item.icon.trim() sin comprobar. */
    icon: string;
    hotel_type?: string;
    hostel_status?: string;
    nota_destacada?: string;
    title?: string;
    type?: string;
}

/**
 * Object to store hotel data from rest list.
 *
 * Example list item.
 * {
 "id":"3352",
 "uri":"https://www.gronze.com.ddev.local/maps20/hotel/3352",
 "url":"https://www.gronze.com.ddev.local/castilla-y-leon/leon/arcahueja/hotel-camino-real",
 "geo_location":{"geom":"POINT (-5.502959489822 42.56641679304)","geo_type":"point","lat":"42.566416793040","lon":"-5.502959489822","left":"-5.502959489822","top":"42.566416793040","right":"-5.502959489822","bottom":"42.566416793040","geohash":"ezs44ubz7g0n8nb5"},
 "icon":"gronze-icon-alojamiento",
 "hotel_type":"Hotel",
 "title":"Hotel Camino Real",
 "type":"alojamiento"},
 }
 */

class HotelData extends PlaceData {

    /**
     * Returns hotel[id]
     */
    getMapItemId(): string {
        return 'hotel' + this.id;
    }

    /**
     * Create from data type, id
     */
    static fromListItem(item: HotelListItem): HotelData {
        const data = new HotelData(dataTypes.hotel, item.id);
        data.restUrl = item.uri;
        data.linkUrl = item.url;
        // @todo Transition from old geo_location (obj) to geo_location_json
        if (item.geo_location_json) {
            data.location = GeoLocation.fromGeoJson(item.geo_location_json);
        }
        else {
            data.location = GeoLocation.fromLatLon(item.geo_location!.lat, item.geo_location!.lon);
        }

        if (item.hostel_status === '1') {
            item.icon = item.icon.trim() + '_closed';
        } else if (item.nota_destacada && item.nota_destacada.length > 1) {
            item.icon = item.icon.trim() + '_warning';
        }
        data.iconClass = item.icon;

        data.name = item.title;
        return data;
    }

    /**
     * Create DOM Element
     */
    createElement(): HTMLElement {
        const el = super.createElement();
        // Detect if this item is currently selected by checking MapData, not the DOM
        const isSelected = MapData.hotelList.getSelectedPlace()?.id === this.id;
        // Si por nivel de zoom no toca mostrar alojamientos, no dibujamos nada (ni icono ni placeholder).
        if (!GeoService.showHotels(MapData.zoom)) {
            el.className = '';
            el.innerHTML = '';
            return el;
        }
        const showHotels = VisibilityService.getShowHotels(); // '1' | '0'
        const zoom = MapData.zoom ?? 0;
        const zoomMarkersAlwaysShown = Config.config().zoom_level_markers_always_shown ?? 18;
        const forceShowByZoom = zoom >= zoomMarkersAlwaysShown;

        if (showHotels === '1') {
            el.className = dataClass.hotel + ' icon glyphicons ' + this.iconClass;
            if (GeoService.showHotelNames(MapData.zoom)) {
                el.innerHTML = `<div class="accomodation-name">${this.name}</div>`;
            } else {
                el.innerHTML = '';
            }
        } else {
            // Sin icono: solo un marcador minimal con estilo CSS
            // Mantenemos la clase del icono para aplicar el color de fondo correspondiente
            el.className = dataClass.hotel + ' iconHide ' + this.iconClass;
            if (forceShowByZoom) {
                el.classList.add('marker-always-shown');
                el.classList.add('icon', 'glyphicons');
                if (GeoService.showHotelNames(MapData.zoom)) {
                    el.innerHTML = `<div class="accomodation-name">${this.name}</div>`;
                }
            } else {
                el.innerHTML = '';
            }
        }
        if (isSelected) el.classList.add('selected');
        return el;
    }

}

export default HotelData;
